(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozy-featured-products"] && !Shopify.designMode) return;
  try {
    
  function cozyUpdateArrowState(grid) {
    var section = grid.closest('.cozy-featured-products');
    if (!section) return;
    var prevBtn = section.querySelector('.cozy-featured-products__arrow--prev');
    if (!prevBtn) return;
    var atStart = grid.scrollLeft <= 1;
    prevBtn.disabled = atStart;
    prevBtn.classList.toggle('is-disabled', atStart);
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cozy-featured-products__grid').forEach(function(grid) {
      cozyUpdateArrowState(grid);
      grid.addEventListener('scroll', function() {
        cozyUpdateArrowState(grid);
      }, { passive: true });
    });
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.cozy-featured-products__arrow');
    if (!button || button.disabled) return;
    var section = button.closest('.cozy-featured-products');
    var grid = section && section.querySelector('.cozy-featured-products__grid');
    if (!grid) return;
    var firstCard = grid.querySelector('.cozy-best-card');
    var distance = firstCard ? firstCard.getBoundingClientRect().width + 30 : 320;
    if (button.classList.contains('cozy-featured-products__arrow--prev')) {
      grid.scrollBy({ left: -distance, behavior: 'smooth' });
    } else {
      grid.scrollBy({ left: distance, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatMoney(amount) {
      var value = parseFloat(amount);
      if (isNaN(value)) return '';
      var currency = 'USD';
      try {
        if (window.Shopify && Shopify.currency && Shopify.currency.active) {
          currency = Shopify.currency.active;
        }
        return new Intl.NumberFormat(navigator.language || 'en-US', {
          style: 'currency',
          currency: currency
        }).format(value);
      } catch (e) {
        return '$' + value.toFixed(2);
      }
    }

    function initCozySearch(wrapper) {
      var form = wrapper.querySelector('[data-cozy-search-form]');
      var panel = wrapper.querySelector('[data-cozy-search-panel]');
      var resultsEl = wrapper.querySelector('[data-cozy-search-results]');
      var input = form.querySelector('input[name="q"]');
      var predictiveUrl = form.getAttribute('data-predictive-search-url');
      var debounceTimer;
      var currentController;

      function closePanel() {
        panel.hidden = true;
        resultsEl.innerHTML = '';
      }

      function openPanel() {
        panel.hidden = false;
      }

      function renderLoading() {
        resultsEl.innerHTML = '<div class="cozy-header__search-loading">Searching…</div>';
        openPanel();
      }

      function renderResults(products, query) {
        if (!products.length) {
          resultsEl.innerHTML = '<div class="cozy-header__search-empty">No results for "' + query + '".</div>';
          openPanel();
          return;
        }
        var html = products.map(function (product) {
          var image = product.featured_image ? product.featured_image.url : '';
          var imgTag = image ? '<img src="' + image + '" alt="" loading="lazy" width="56" height="56">' : '';
          return (
            '<a class="cozy-header__search-result" href="' + product.url + '">' +
              imgTag +
              '<span class="cozy-header__search-result-info">' +
                '<strong>' + product.title + '</strong>' +
                '<span>' + formatMoney(product.price) + '</span>' +
              '</span>' +
            '</a>'
          );
        }).join('');
        html += '<a class="cozy-header__search-viewall" href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(query) + '">View all results</a>';
        resultsEl.innerHTML = html;
        openPanel();
      }

      function runSearch(query) {
        if (currentController) currentController.abort();
        currentController = new AbortController();

        if (!predictiveUrl) {
          console.error('[Cozy search] data-predictive-search-url is empty. Check that routes.predictive_search_url is rendering in the form markup.');
          resultsEl.innerHTML = '<div class="cozy-header__search-empty">Search is not configured correctly.</div>';
          openPanel();
          return;
        }

        var url = predictiveUrl +
          '?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor';

        fetch(url, {
          signal: currentController.signal,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) {
              throw new Error('Predictive search request failed with status ' + res.status + ' ' + res.statusText);
            }
            return res.text();
          })
          .then(function (text) {
            var data;
            try {
              data = JSON.parse(text);
            } catch (parseErr) {
              console.error('[Cozy search] Response was not valid JSON. Raw response:', text.slice(0, 500));
              throw new Error('Response was not valid JSON');
            }
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products, query);
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            console.error('[Cozy search] Search failed:', err);
            resultsEl.innerHTML = '<div class="cozy-header__search-empty">Something went wrong. Please try again.</div>';
            openPanel();
          });
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearTimeout(debounceTimer);
        if (query.length < 2) {
          closePanel();
          return;
        }
        renderLoading();
        debounceTimer = setTimeout(function () { runSearch(query); }, 250);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var query = input.value.trim();
        if (query.length < 2) return;
        renderLoading();
        runSearch(query);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closePanel();
          input.blur();
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) closePanel();
      });
    }

    document.querySelectorAll('[data-cozy-search-wrapper]').forEach(initCozySearch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cozy-testimonials"] && !Shopify.designMode) return;
  try {
    
  function cozyUpdateTestimonialArrows(section) {
    var track = section.querySelector('.cozy-testimonials__track');
    var prevBtn = section.querySelector('.cozy-testimonials__arrow--prev');
    var nextBtn = section.querySelector('.cozy-testimonials__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= maxScroll - 1;

    prevBtn.disabled = atStart;
    prevBtn.classList.toggle('is-disabled', atStart);

    nextBtn.disabled = maxScroll <= 1 ? true : atEnd;
    nextBtn.classList.toggle('is-disabled', maxScroll <= 1 ? true : atEnd);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cozy-testimonials').forEach(function (section) {
      cozyUpdateTestimonialArrows(section);
      var track = section.querySelector('.cozy-testimonials__track');
      if (track) {
        track.addEventListener('scroll', function () {
          cozyUpdateTestimonialArrows(section);
        }, { passive: true });
      }
    });
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.cozy-testimonials__arrow');
    if (!button || button.disabled) return;
    var section = button.closest('.cozy-testimonials');
    var track = section && section.querySelector('.cozy-testimonials__track');
    if (!track) return;
    var distance = track.getBoundingClientRect().width;
    if (button.classList.contains('cozy-testimonials__arrow--prev')) {
      track.scrollBy({ left: -distance, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: distance, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;

    const input = button.parentElement.querySelector('input[type="number"]');
    if (!input) return;

    if (button.hasAttribute('data-quantity-plus')) input.stepUp();
    if (button.hasAttribute('data-quantity-minus')) input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-cart-discount-form]');
    if (!form) return;

    event.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const code = input ? input.value.trim() : '';
    if (!code) return;

    const discountUrl = form.dataset.discountBase + encodeURIComponent(code);
    window.location.assign(discountUrl + '?redirect=' + encodeURIComponent(form.dataset.cartRedirect));
  });

  } catch(e) { console.error(e); }
})();
})();
